module.exports = __webpack_public_path__ + "static/media/ios-step4.1a5d90d5.png";